// COMPROBANTE DE RETENCION IVA ELECTRONICO (CRE)
export enum COMPROBANTE_RETENCION_TYPES {
  CRE_TYPE_FORMCLIENTE_HANDLE_CHANGE = 'CRE_TYPE_FORMCLIENTE_HANDLE_CHANGE',
  CRE_TYPE_FORMCLIENTE_SET_ERRORS = 'CRE_TYPE_FORMCLIENTE_SET_ERRORS',
  CRE_TYPE_FORMSUCURSAL_HANDLE_CHANGE = 'CRE_TYPE_FORMSUCURSAL_HANDLE_CHANGE',
  CRE_TYPE_FORMSUCURSAL_SET_ERRORS = 'CRE_TYPE_FORMSUCURSAL_SET_ERRORS',
  CRE_TYPE_ARRAYPRODUCTOS_EDIT = 'CRE_TYPE_ARRAYPRODUCTOS_EDIT',
  CRE_TYPE_ARRAYPRODUCTOS_SET_CALCULOS = 'CRE_TYPE_ARRAYPRODUCTOS_SET_CALCULOS',
  CRE_TYPE_ARRAYPRODUCTOS_CLEAR_ALL = 'CRE_TYPE_ARRAYPRODUCTOS_CLEAR_ALL',
  CRE_TYPE_ARRAYPRODUCTOS_SELECT_ONE = 'CRE_TYPE_ARRAYPRODUCTOS_SELECT_ONE',
  CRE_TYPE_ARRAYPRODUCTOS_DELETE_ONE = 'CRE_TYPE_ARRAYPRODUCTOS_DELETE_ONE',
  CRE_TYPE_CLEAR_ALL = 'CRE_TYPE_CLEAR_ALL',
  CRE_TYPE_SET_DATOS_EMISOR = 'CRE_TYPE_SET_DATOS_EMISOR',
  CRE_TYPE_SET_DATOS_FACTURA = 'CRE_TYPE_SET_DATOS_FACTURA',
  CRE_TYPE_FACTURA_EMITIDA = 'CRE_TYPE_FACTURA_EMITIDA',
  CRE_TYPE_OPCIONES_ACTIVA = 'CRE_TYPE_OPCIONES_ACTIVA',
  CRE_TYPE_SET_CATALOGO_SUCURSAL = 'CRE_TYPE_SET_CATALOGO_SUCURSAL',
  CRE_TYPE_SET_CATALOGO_SERIE = 'CRE_TYPE_SET_CATALOGO_SERIE',
  CRE_TYPE_SET_UUID = 'CRE_TYPE_SET_UUID',
  CRE_TYPE_ANULADO = 'CRE_TYPE_ANULADO',

  // DOCUMENTOS ASOCIADOS
  CRE_TYPE_MODALDOCUMENTO_SETOPEN = "CRE_TYPE_MODALDOCUMENTO_SETOPEN",
  CRE_TYPE_MODALDOCUMENTO_FORM_HANDLECHANGE = "CRE_TYPE_MODALDOCUMENTO_FORM_HANDLECHANGE",
  CRE_TYPE_MODALDOCUMENTO_ADD_ERRORS = "CRE_TYPE_MODALDOCUMENTO_ADD_ERRORS",
  CRE_TYPE_MODALDOCUMENTO_SET_LOADER = "CRE_TYPE_MODALDOCUMENTO_SET_LOADER",
  CRE_TYPE_MODALDOCUMENTO_SET_DOCUMENTOS = "CRE_TYPE_MODALDOCUMENTO_SET_DOCUMENTOS",
  CRE_TYPE_MODALDOCUMENTO_SET_USER = "CRE_TYPE_MODALDOCUMENTO_SET_USER",
  CRE_TYPE_DOCUMENTO_ASOCIAR = "CRE_TYPE_DOCUMENTO_ASOCIAR",
  CRE_TYPE_DOCUMENTO_DESASOCIAR = "CRE_TYPE_DOCUMENTO_DESASOCIAR",
  
  // DOCUMENTOS FISICO
  CRE_TYPE_FISICO_HANDLE_CHANGE = "CRE_TYPE_FISICO_HANDLE_CHANGE",
  CRE_TYPE_FISICO_ADD_ERRORS = "CRE_TYPE_FISICO_ADD_ERRORS",
  CRE_TYPE_FISICO_MODAL_SETOPEN = "CRE_TYPE_FISICO_MODAL_SETOPEN",
  CRE_TYPE_FISICO_SETEDIT = "CRE_TYPE_FISICO_SETEDIT",
  CRE_TYPE_FISICO_EDITAR_DOC = "CRE_TYPE_FISICO_EDITAR_DOC",
  CRE_TYPE_FISICO_CLEAR = "CRE_TYPE_FISICO_CLEAR",

  // MODALS
  CRE_TYPE_MODALELIMINAR_OPEN = 'CRE_TYPE_MODALELIMINAR_OPEN',
  CRE_TYPE_MODALELIMINAR_CLOSE = 'CRE_TYPE_MODALELIMINAR_CLOSE',
  CRE_TYPE_MODALEDITAR_OPEN = 'CRE_TYPE_MODALEDITAR_OPEN',
  CRE_TYPE_MODALEDITAR_CLOSE = 'CRE_TYPE_MODALEDITAR_CLOSE',
  CRE_TYPE_MODALFACTURACION_OPEN = 'CRE_TYPE_MODALFACTURACION_OPEN',
  CRE_TYPE_MODALIMPRESION_OPEN = 'CRE_TYPE_MODALIMPRESION_OPEN',
  CRE_TYPE_MODALEMAIL_OPEN = 'CRE_TYPE_MODALEMAIL_OPEN',
  CRE_TYPE_MODALANULAR_OPEN = 'CRE_TYPE_MODALANULAR_OPEN',
  CRE_TYPE_FORMOBSERVACIONES_HANDLE_CHANGE = 'CRE_TYPE_FORMOBSERVACIONES_HANDLE_CHANGE',
}
